var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.49692H4.5C3.7998 5.49692 3.7998 6.49625 4.5 6.49625H10.5C11.0996 6.49625 11.1992 5.49692 10.5 5.49692Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.49496H8.5C9.19922 8.49496 9.09961 9.49429 8.5 9.49429H4.5C3.7998 9.49429 3.7998 8.49496 4.5 8.49496Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.49948H15C15.5996 1.49948 16 1.8992 16 2.49881V12.4924C16 13.0921 15.5996 13.4918 15 13.4918H6.40039L4.7002 15.1907C4 15.8902 3 15.2906 3 14.4911V13.4918H1C0.400391 13.4918 0 13.0921 0 12.4924V2.49881C0 1.8992 0.400391 1.49948 1 1.49948ZM2 11.4931H14V3.4982H2V11.4931Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.812f83256fd883fd379adba14025219c.svg";
export { ForwardRef as ReactComponent };